import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Button, Dropdown, Layout, Menu } from "antd";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../assets/css/Header.css";
import erpLogo from "../assets/images/erpLogo.svg";
import posLogo from "../assets/images/posLogo.svg";
import menuConfig from "./menu.json";

import {
  BarChartOutlined,
  CalculatorOutlined,
  FileTextOutlined,
  HomeOutlined,
  SettingOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  TeamOutlined,
} from "@ant-design/icons";

// Import SVGs or icons
import { useNavigate } from "react-router-dom";
import add from "../assets/images/add.svg";
import admin from "../assets/images/admin.svg";
import apps from "../assets/images/apps.svg";
import backarrow from "../assets/images/backarrow.svg";
import bargraph from "../assets/images/bar-graph.svg";
import buisness from "../assets/images/business.jpeg";
import calSvg from "../assets/images/cal.svg";
import ccSvg from "../assets/images/cc.svg";
import chatSvg from "../assets/images/chat.svg";
import checklist from "../assets/images/checklist.svg";
import checkout from "../assets/images/checkout.svg";
import creditcardpayment from "../assets/images/credit-card-payment.svg";
import creditcard from "../assets/images/credit-card.svg";
import crmSvg from "../assets/images/crm.svg";
import customer from "../assets/images/customer.svg";
import dashboardPX from "../assets/images/dashboardpx.svg";
import dairy from "../assets/images/diary.svg";
import employee from "../assets/images/employee.svg";
import enquiry from "../assets/images/enquiry.svg";
import execution from "../assets/images/execution.svg";
import eye from "../assets/images/eye.svg";
import file from "../assets/images/file.svg";
import gear from "../assets/images/gear.svg";
import heart from "../assets/images/heart.svg";
import homeSvg from "../assets/images/home.svg";
import hr from "../assets/images/hr.svg";
import invSvg from "../assets/images/inv.svg";
import inventory from "../assets/images/inventory.svg";
import jobSearchSvg from "../assets/images/job-search.svg";
import keys from "../assets/images/keys.svg";
import label from "../assets/images/label.svg";
import loginlogo from "../assets/images/login_logo.svg";
import logoSvg from "../assets/images/logo.svg";
import menuicon from "../assets/images/menuicon.svg";
import myaccount from "../assets/images/myaccount.svg";
import newspaper from "../assets/images/newspaper.svg";
import notificationSvg from "../assets/images/notification.svg";
import ob from "../assets/images/ob.svg";
import op from "../assets/images/op.svg";
import order from "../assets/images/order.svg";
import orders from "../assets/images/orders.svg";
import people from "../assets/images/people.svg";
import pointofservice from "../assets/images/point-of-service.svg";
import pos1 from "../assets/images/pos1.svg";
import prod from "../assets/images/prod.svg";
import product from "../assets/images/product.svg";
import products from "../assets/images/products.svg";
import projectSvg from "../assets/images/project.svg";
import project2 from "../assets/images/project2.svg";
import proschool from "../assets/images/proschool.png";
import reminder from "../assets/images/reminder.svg";
import report from "../assets/images/report.svg";
import search from "../assets/images/search.svg";
import settingSvg from "../assets/images/setting.svg";
import statistics from "../assets/images/statistics.svg";
import supplier from "../assets/images/supplier.svg";
import terminalserver from "../assets/images/terminal-server-session.svg";
import user from "../assets/images/user.svg";
import ven from "../assets/images/ven.svg";
import vendor from "../assets/images/vendor.svg";
import { signoff } from "../auth";

const { Header: AntHeader, Sider, Content } = Layout;

const iconMapping = {
  add: add,
  admin: admin,
  apps: apps,
  backarrow: backarrow,
  bargraph: bargraph,
  buisness: buisness,
  cal: calSvg,
  cc: ccSvg,
  chat: chatSvg,
  checklist: checklist,
  checkout: checkout,
  creditcardpayment: creditcardpayment,
  creditcard: creditcard,
  crm: crmSvg,
  customer: customer,
  dashboardPX: dashboardPX,
  dairy: dairy,
  employee: employee,
  enquiry: enquiry,
  execution: execution,
  eye: eye,
  file: file,
  gear: gear,
  heart: heart,
  home: homeSvg,
  hr: hr,
  inv: invSvg,
  inventory: inventory,
  jobSearch: jobSearchSvg,
  keys: keys,
  label: label,
  loginlogo: loginlogo,
  logo: logoSvg,
  menuicon: menuicon,
  myaccount: myaccount,
  newspaper: newspaper,
  notification: notificationSvg,
  ob: ob,
  op: op,
  order: order,
  orders: orders,
  people: people,
  pointofservice: pointofservice,
  pos: pos1,
  pos1: pos1,
  prod: prod,
  product: product,
  products: products,
  project: projectSvg,
  project2: project2,
  proschool: proschool,
  reminder: reminder,
  report: report,
  search: search,
  setting: settingSvg,
  statistics: statistics,
  supplier: supplier,
  terminalserver: terminalserver,
  user: user,
  ven: ven,
  vendor: vendor,
};
const antIconMapping = {
  home: <HomeOutlined />,
  customers: <TeamOutlined />,
  Vendors: <ShopOutlined />,
  Accounting: <CalculatorOutlined />,
  Reporting: <BarChartOutlined />,
  Configuration: <SettingOutlined />,
  orders: <ShoppingCartOutlined />,
  products: <ShoppingCartOutlined />,
  report: <FileTextOutlined />,
  setting: <SettingOutlined />,
};

const Header = ({ children }) => {
  const auth = JSON.parse(localStorage.getItem("auth"));
  const username = auth?.full_name;
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [searchVisible, setSearchVisible] = useState(false);
  const [menuItems, setMenuItems] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);

  const location = useLocation();

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const toggleSearch = () => {
    setSearchVisible(!searchVisible);
  };
  const logout = () => {
    signoff().then(() => {
      localStorage.clear();
      navigate("/");
    });
  };

  useEffect(() => {
    if (!location || !location.pathname) return;

    const section = "pos"; // you can make this dynamic later
    const currentMenu = menuConfig[section] || [];

    // format menu
    const formattedItems = currentMenu.map((item) => ({
      key: item.key,
      icon: antIconMapping[item.icon] || (
        <img
          src={iconMapping[item.icon]}
          alt={item.label}
          className="mr-2 mb-1 s-imgs"
        />
      ),
      label: (
        <Link
          to={item.link || "#"}
          className="text-white"
          style={{ textDecoration: "none" }}
        >
          {item.label}
        </Link>
      ),
      children:
        item.children?.map((subItem) => ({
          key: subItem.key,
          label: (
            <Link
              to={subItem.link}
              className="text-white"
              style={{ textDecoration: "none" }}
            >
              {subItem.label}
            </Link>
          ),
        })) || null,
    }));

    setMenuItems(formattedItems);

    // === Find selected + open keys ===
    const findKeys = (items, path) => {
      for (const item of items) {
        if (item.link && path.startsWith(item.link)) {
          return { selected: item.key, open: null };
        }
        if (item.children) {
          for (const child of item.children) {
            if (child.link && path.startsWith(child.link)) {
              return { selected: child.key, open: item.key };
            }
          }
        }
      }
      return { selected: null, open: null };
    };

    const { selected, open } = findKeys(currentMenu, location.pathname);

    if (selected) setSelectedKeys([selected]);
    if (open) setOpenKeys([open]);
  }, [location]);

  const dropdownItems = [
    {
      key: "1",
      label: (
        <a
          href="https://proerp.defconinnovations.com/dashboard"
          target="_blank"
          rel="noopener noreferrer"
        >
          My Account
        </a>
      ),
    },
    {
      key: "2",
      label: (
        <a
          href="https://proerp.defconinnovations.com/billings"
          target="_blank"
          rel="noopener noreferrer"
        >
          Billings
        </a>
      ),
    },
    {
      key: "3",
      label: (
        <a
          href="https://proerp.defconinnovations.com/settings"
          target="_blank"
          rel="noopener noreferrer"
        >
          Settings
        </a>
      ),
    },
    {
      key: "4",
      label: (
        <Button className="text-start justify-start" onClick={logout}>
          Logout
        </Button>
      ),
    },
  ];

  return (
    <Layout>
      <AntHeader
        style={{
          background: "#fff",
          padding: "0 16px",
          position: "fixed",
          width: "100%",
          zIndex: 1000,
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <Button
            type="none"
            onClick={toggleCollapsed}
            style={{ fontSize: "30px" }}
          >
            <img
              src={posLogo}
              alt="Menu"
              width={40}
              style={{
                display: "inline-block",
                padding: "15px 0px",
                verticalAlign: "top",
              }}
            />
            <span
              style={{
                fontSize: "24px",
                fontWeight: "700",
                display: "inline-block",
                padding: "0px 10px",
                color: "#1e2a53",
              }}
            >
              POS
            </span>
          </Button>
          <div className="d-flex align-items-center">
            <Dropdown menu={{ items: dropdownItems }} trigger={["click"]}>
              <Button
                className="ant-dropdown-link"
                onClick={(e) => e.preventDefault()}
                icon={<UserOutlined />}
              >
                {username || "User"} <DownOutlined />
              </Button>
            </Dropdown>

            <a
              href="https://proerp.defconinnovations.com/dashboard"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Avatar
                src={erpLogo}
                style={{
                  marginLeft: 16,
                  cursor: "pointer",
                  borderRadius: "unset",
                }}
              />
            </a>
          </div>
        </div>
      </AntHeader>
      <Layout style={{ marginTop: 64, color: "#fff" }}>
        <Sider
          trigger={null}
          collapsible
          collapsed={collapsed}
          width={270}
          style={{
            background: "#fff",
            transition: "0.2s ease",
            overflow: "auto",
            color: "#fff",
            height: "100vh",
            position: "sticky",
            insetInlineStart: 0,
            top: 0,
            bottom: 0,
            scrollbarWidth: "thin",
            scrollbarGutter: "stable",
          }}
        >
          <div className="sidebar-content">
            <div className="row mx-2">
              <div className="col-12">
                <Menu
                  mode="inline"
                  items={menuItems}
                  selectedKeys={selectedKeys}
                  openKeys={collapsed ? [] : openKeys}
                  onOpenChange={(keys) => setOpenKeys(keys)}
                  onClick={(e) => setSelectedKeys([e.key])}
                  style={{
                    color: "#8C8C8C",
                    border: "none",
                    background: "transparent",
                  }}
                />
              </div>
              <div className="col-12">
                {!collapsed && (
                  <div className="row mx-3 mt-5 mb-1 navs">
                    {/* <div className="col-4">
                      <img className="ml-3" src={settingSvg} alt="Settings" />
                    </div>
                    <div className="col-4">
                      <a href="/chatapp/notifications">
                        <img
                          className="ml-1"
                          src={notificationSvg}
                          alt="Notifications"
                        />
                      </a>
                    </div>
                    <div className="col-4">
                      <a href="/chatapp">
                        <img className="ml-1" src={chatSvg} alt="Chat" />
                      </a>
                    </div> */}
                    <div className="col-12 mt-3">
                      <p className="power text-center">
                        Powered by{" "}
                        <span className="techies">Defcon Innovations</span>
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Sider>
        <Layout>
          <Content style={{ marginTop: "64px" }}>
            {/* Main content goes here */}
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default Header;
